const CostCentersStructure = () => {
  return <></>
}

export { CostCentersStructure }
